import { styleSheet } from './styles';
import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
	account: Api.IAccount;
	/** When true, force the indicator red and enlarge it so a cancelled account is unmistakable. */
	isCancelled?: boolean;
}

export const AccountStatusIndicator: React.FC<IProps> = props => {
	const { className, styles, account, isCancelled } = props;
	const color = account?.usage?.statusColor || 'gray';
	let colorClass;

	switch (color) {
		case 'green':
			colorClass = styleSheet.accountStatusGreen;
			break;
		case 'orange':
			colorClass = styleSheet.accountStatusOrange;
			break;
		case 'red':
			colorClass = styleSheet.accountStatusRed;
			break;
		case 'yellow':
			colorClass = styleSheet.accountStatusYellow;
			break;
		default:
			colorClass = styleSheet.accountStatusGray;
			break;
	}

	// A cancelled account must never read as healthy: force red and emphasize regardless of usage.statusColor.
	if (isCancelled) {
		colorClass = styleSheet.accountStatusCancelled;
	}

	return (
		<span
			className={`${css(styleSheet.adminAccountStatus, isCancelled ? styleSheet.adminAccountStatusCancelled : null, ...(styles || []))} ${css(colorClass)} ${className || ''}`}
		/>
	);
};
